const accessibilityHelpers = () => {
    //Header Navigation tabindex setting
    //matchmedia for smaller than most tablets landscape
    const mq = window.matchMedia('(min-width: 992px)');
    if (!mq.matches) {
        //detach main-navigation element and append as last child of parent element
        const headerNav = document.querySelector('.main-navigation');
        const headerNavParent = headerNav.parentNode;
        headerNav.parentNode.removeChild(headerNav);
        headerNavParent.appendChild(headerNav);
    }
}

export default accessibilityHelpers;